import React from 'react';
import {Link} from 'react-router-dom';
import AnalyticsPreferences from '../analytics/AnalyticsPreferences';
import '../components/profile/CustomerProfile.css';
export default function PrivacyPreferences(){return <main className="privacy-preferences-page"><h1>Privacy e preferenze</h1><AnalyticsPreferences/><p>Le preferenze marketing email e push sono disponibili in Account → Privacy dopo l’accesso.</p><p><Link to="/profilo">Account e preferenze marketing</Link></p><Link to="/">Torna a StirUp</Link></main>;}
